<main id="page-auth" class="page-auth">
  <section>
      <article class="auth-box">
          <div class="auth-box__form">
            <div class="header">
                <img src="/assets/images/logo-ubaristi.svg" alt="Ubaristi" title="Ubaristi" class="logo">
                <p class="text" translate>auth.login.completeAllFields</p>
            </div>
          <app-login-form (login)="onLogin($event)"></app-login-form>
          </div>
      </article>
  </section>
</main>



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/auth/login/login.component.html